import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Input } from '../ui'
import { FormField } from '../ui/Form'

interface FormModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  inputLabel: string
  inputValue: string
  onInputChange: (value: string) => void
  inputPlaceholder?: string
  inputRequired?: boolean
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  isLoading?: boolean
  loadingText?: string
  disabled?: boolean
}

const FormModal: React.FC<FormModalProps> = ({
  isOpen,
  onClose,
  title,
  inputLabel,
  inputValue,
  onInputChange,
  inputPlaceholder = '',
  inputRequired = false,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  isLoading = false,
  loadingText = 'Cargando...',
  disabled = false
}) => {
  if (!isOpen) return null

  const handleConfirm = () => {
    if (!disabled && !isLoading) {
      onConfirm()
    }
  }

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
      <div className="relative bg-white rounded-lg shadow-xl p-8 m-4 max-w-md w-full">
        <div className="flex justify-between items-center mb-6">
          <h3 >{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="space-y-6">
          <FormField
            label={inputLabel}
            required={inputRequired}
          >
            <Input
              type="text"
              value={inputValue}
              onChange={(e) => onInputChange(e.target.value)}
              placeholder={inputPlaceholder}
              disabled={isLoading}
              isLoading={isLoading}
            />
          </FormField>

          <div className="flex justify-end space-x-4 mt-6">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {cancelText}
            </button>
            <button
              onClick={handleConfirm}
              disabled={disabled || isLoading}
              className={`px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors ${
                disabled || isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isLoading ? loadingText : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormModal
